// Product Gallery with SwiperJS
(function() {
  'use strict';

  console.log('[ProductGallery] Script loaded');

  // Wait for DOM to be ready
  function ready(fn) {
    if (document.readyState != 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  // Load SwiperJS from CDN if not already loaded
  function loadSwiper(callback) {
    console.log('[ProductGallery] Loading Swiper...');
    
    if (window.Swiper) {
      console.log('[ProductGallery] Swiper already loaded');
      callback();
      return;
    }

    // Load Swiper CSS
    const swiperCSS = document.createElement('link');
    swiperCSS.rel = 'stylesheet';
    swiperCSS.href = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
    swiperCSS.onload = function() {
      console.log('[ProductGallery] Swiper CSS loaded');
    };
    document.head.appendChild(swiperCSS);

    // Load Swiper JS
    const swiperJS = document.createElement('script');
    swiperJS.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
    swiperJS.onload = function() {
      console.log('[ProductGallery] Swiper JS loaded');
      callback();
    };
    swiperJS.onerror = function() {
      console.error('[ProductGallery] Failed to load Swiper JS');
    };
    document.head.appendChild(swiperJS);
  }

  function ProductGallery() {
    console.log('[ProductGallery] Initializing ProductGallery...');
    
    // State management
    const state = {
      gallery: document.querySelector('[data-component="product-gallery"]'),
      mainSwiper: null,
      lazyLoadObserver: null
    };

    console.log('[ProductGallery] Gallery element found:', !!state.gallery);

    // Intersection Observer for lazy loading
    function initLazyLoading() {
      console.log('[ProductGallery] Initializing lazy loading...');
      
      if ('IntersectionObserver' in window) {
        state.lazyLoadObserver = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              const img = entry.target;
              console.log('[ProductGallery] Loading lazy image:', img.src);
              loadLazyImage(img);
              state.lazyLoadObserver.unobserve(img);
            }
          });
        }, {
          rootMargin: '100px'
        });

        // Observe all lazy images
        const lazyImages = document.querySelectorAll('img.lazy');
        console.log('[ProductGallery] Found lazy images:', lazyImages.length);
        lazyImages.forEach(function(img) {
          state.lazyLoadObserver.observe(img);
        });
      } else {
        // Fallback for browsers without IntersectionObserver
        const lazyImages = document.querySelectorAll('img.lazy');
        console.log('[ProductGallery] Fallback: Loading all lazy images:', lazyImages.length);
        lazyImages.forEach(loadLazyImage);
      }
    }

    function loadLazyImage(img) {
      if (img.dataset.src) {
        img.src = img.dataset.src;
      }
      if (img.dataset.srcset) {
        img.srcset = img.dataset.srcset;
      }
      if (img.dataset.sizes) {
        img.sizes = img.dataset.sizes;
      }

      // Remove lazy class and add loading state
      img.classList.remove('lazy');
      img.classList.add('loading');

      // Handle load completion
      img.addEventListener('load', function() {
        img.classList.remove('loading');
        img.classList.add('loaded');
      }, { once: true });

      img.addEventListener('error', function() {
        img.classList.remove('loading');
        img.classList.add('error');
        console.warn('[ProductGallery] Failed to load image:', img.src);
      }, { once: true });
    }

    // Initialize main gallery
    function initMainGallery() {
      console.log('[ProductGallery] Initializing main gallery...');
      
      if (!state.gallery) {
        console.log('[ProductGallery] No gallery element found');
        return;
      }
      
      // Check if we're on mobile (disable Swiper on desktop)
      const isMobile = window.innerWidth < 768;
      if (!isMobile) {
        console.log('[ProductGallery] Desktop detected, skipping Swiper initialization');
        return;
      }
      
      // The gallery element itself is the swiper element
      const swiperElement = state.gallery.classList.contains('product-gallery-swiper') 
        ? state.gallery 
        : state.gallery.querySelector('.product-gallery-swiper');
        
      if (!swiperElement) {
        console.log('[ProductGallery] No swiper element found');
        return;
      }
      
      console.log('[ProductGallery] Swiper element found:', swiperElement.className);

      // Check if there are multiple slides
      const slides = swiperElement.querySelectorAll('.swiper-slide');
      console.log('[ProductGallery] Found slides:', slides.length);
      
      if (slides.length <= 1) {
        console.log('[ProductGallery] Only one slide, skipping swiper initialization');
        return;
      }

      // Swiper configuration (mobile only)
      const swiperConfig = {
        slidesPerView: 1.5,
        spaceBetween: 10,
        loop: true,
        effect: 'slide',
        speed: 300,
        allowTouchMove: true,
        simulateTouch: true,
        centeredSlides: false,
        navigation: {
          nextEl: swiperElement.querySelector('.swiper-button-next'),
          prevEl: swiperElement.querySelector('.swiper-button-prev')
        },
        on: {
          init: function() {
            console.log('[ProductGallery] Swiper initialized successfully');
          },
          slideChange: function() {
            console.log('[ProductGallery] Slide changed to:', this.activeIndex);
            
            // Load images in upcoming slides when user starts navigating
            const activeIndex = this.activeIndex;
            const nextSlide = this.slides[activeIndex + 1];
            const prevSlide = this.slides[activeIndex - 1];

            [nextSlide, prevSlide].forEach(function(slide) {
              if (slide) {
                const lazyImages = slide.querySelectorAll('img.lazy');
                lazyImages.forEach(loadLazyImage);
              }
            });
          }
        }
      };

      console.log('[ProductGallery] Creating Swiper instance...');
      try {
        state.mainSwiper = new Swiper(swiperElement, swiperConfig);
        console.log('[ProductGallery] Swiper created successfully');
      } catch (error) {
        console.error('[ProductGallery] Error creating Swiper:', error);
      }
    }

    // Lifecycle
    function destroy() {
      if (state.mainSwiper) {
        state.mainSwiper.destroy();
      }
      if (state.lazyLoadObserver) {
        state.lazyLoadObserver.disconnect();
      }
    }

    function init() {
      initMainGallery();
      initLazyLoading();
    }

    // Initialize
    init();

    return {
      destroy: destroy,
      loadLazyImage: loadLazyImage,
      lazyLoadObserver: state.lazyLoadObserver
    };
  }

  // Initialize when DOM is ready and Swiper is loaded
  ready(function() {
    console.log('[ProductGallery] DOM ready');
    const galleryElement = document.querySelector('[data-component="product-gallery"]');
    
    if (galleryElement) {
      console.log('[ProductGallery] Gallery element found, loading Swiper...');
      loadSwiper(function() {
        console.log('[ProductGallery] Swiper loaded, initializing gallery...');
        ProductGallery();
      });
    } else {
      console.log('[ProductGallery] No gallery element found on this page');
    }
  });

})(); 